//------------------------------------------------------------------------------
// マスター情報 型定義
//------------------------------------------------------------------------------
// アクション種別
export default {

  // 汎用マスタ
  GENERIC: 'MASTER/GENERIC',

  // 地区マスタ
  AREAS: 'MASTER/AREAS',

  // 事業場マスタ TODO 削除
  ZIG_HAIDEN: 'MASTER/ZIG_HAIDEN',  // 配電
  ZIG_TUSHIN: 'MASTER/ZIG_TUSHIN',  // 通信

  // マスタ取得状態
  LOADED: 'MASTER/LOADED',
};
